import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    current: {},
    tenants: [],
  },

  getters: {
    current: state => state.current,
    tenants: state => state.tenants,
    name: state => state.current && state.current.name,
    id: state => state.current && state.current.id,
  },

  mutations: {
    tenants(state, data) {
      state.tenants = data.tenants;
    },

    current(state, data) {
      state.current = data.current;
    },

    reset(state) {
      state.current = {};
      state.tenants = [];
    },
  },

  actions: {
    async getTenants(ctx, data) {
      if (ctx.state.tenants.length && (!data || !data.refresh)) {
        return ctx.state.tenants;
      }

      const res = await Vue.prototype.$api.get('/tenants')
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            return { data: [] };
          }

          throw err;
        });

      ctx.commit('tenants', { tenants: res.data });
      return ctx.state.tenants;
    },

    async getCurrent(ctx, data) {
      if (data && ctx.state.current.id === data.id) {
        return ctx.state.current;
      }

      const res = await Vue.prototype.$api.get(`/tenants/${data.id}`);

      ctx.commit('current', { current: res.data });

      return res.data;
    },
  },
};
